import { RetailMatchGeographyOption } from "../../../Enums/RetailMatchGeographyOption";
import { ILatLon } from "../../../Models/ILatLon";
import { IRetailMatchJob } from "../../../Models/IRetailMatch";
import { IRetailMatchGeography } from "../../../Models/IRetailMatchGeography";
import { ISubmitRetailMatchJobRequest } from "../../../Models/Requests/ISubmitRetailMatchJobRequest";
import { IBaseAction } from "../Actions/BaseAction";
import { MatchReportTypeEnum } from "../Enums/MatchReportTypeEnum";

export type SearchedPlaceInfo = {
  name: string;
  placeId: string;
  lat: number;
  lng: number;
};

export type GetRetailMatchGeographiesInitiateAction = IBaseAction<RetailMatchGeographyOption>;
export type GetRetailMatchGeographiesSuccessAction = IBaseAction<IRetailMatchGeography[]>;
export type GetRetailMatchGeographiesFailureAction = IBaseAction<string>;
export type SetLoadingRetailMatchGeographiesAction = IBaseAction<boolean>;
export type SetSearchedPlaceMatchAction = IBaseAction<SearchedPlaceInfo>;
export type SetRetailMatchReportTypeAction = IBaseAction<MatchReportTypeEnum>;

export type SubmitMatchReportIniitiateAction = IBaseAction<ISubmitRetailMatchJobRequest>;
export type SubmitMatchReportSuccessAction = IBaseAction<IRetailMatchJob>;
export type SubmitMatchReportFailureAction = IBaseAction<string>;
export type SetLoadingMatchReportAction = IBaseAction<boolean>;
export type StartLastReportRunningAction = IBaseAction<string>;
export type IgnoreRunningReportAction = IBaseAction<string>;
export type ResetRetailMatchAction = IBaseAction<number>;
export type RestartRetailMatch = IBaseAction<null>;
export type SetIncludeAllBudsAction = IBaseAction<boolean>;
export type SetMostRecentlySubmittedMobilyticsReportAction = IBaseAction<IRetailMatchJob | null>;
export type SiteIsInDMAInitiateAction = IBaseAction<ILatLon>;
export type SiteIsInDMASuccessAction = IBaseAction<boolean>;
export type SiteIsInDMAFailureAction = IBaseAction<string>;
export type CheckingSiteIsInDMAAction = IBaseAction<boolean>;

export type RetailMatchActionType =
    GetRetailMatchGeographiesInitiateAction
    | GetRetailMatchGeographiesSuccessAction
    | GetRetailMatchGeographiesFailureAction
    | SetLoadingRetailMatchGeographiesAction
    | SubmitMatchReportIniitiateAction
    | SubmitMatchReportSuccessAction
    | SubmitMatchReportFailureAction
    | SetLoadingMatchReportAction
    | SetSearchedPlaceMatchAction
    | SetRetailMatchReportTypeAction
    | StartLastReportRunningAction
    | IgnoreRunningReportAction
    | ResetRetailMatchAction
    | RestartRetailMatch
    | SetIncludeAllBudsAction
    | SetMostRecentlySubmittedMobilyticsReportAction
    | SiteIsInDMAInitiateAction
    | SiteIsInDMASuccessAction
    | SiteIsInDMAFailureAction
    | CheckingSiteIsInDMAAction;

export const GET_RETAIL_MATCH_GEOGRAPHIES_INITIATE
  = "GET_RETAIL_MATCH_GEOGRAPHIES_INITIATE";
export const GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS
  = "GET_RETAIL_MATCH_GEOGRAPHIES_SUCCESS";
export const GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE
  = "GET_RETAIL_MATCH_GEOGRAPHIES_FAILURE";
export const SET_LOADING_RETAIL_MATCH_GEOGRAPHIES
  = "SET_LOADING_RETAIL_MATCH_GEOGRAPHIES";

export const SUBMIT_MATCH_REPORT_INITIATE = "SUBMIT_MATCH_REPORT_INITIATE";
export const SUBMIT_MATCH_REPORT_SUCCESS = "SUBMIT_MATCH_REPORT_SUCCESS";
export const SUBMIT_MATCH_REPORT_FAILURE = "SUBMIT_MATCH_REPORT_FAILURE";
export const SET_LOADING_MATCH_REPORT = "SET_LOADING_MATCH_REPORT";
export const SET_SEARCHED_PLACE_MATCH_ACTION = "SET_SEARCHED_PLACE_MATCH_ACTION";
export const SET_MATCH_REPORT_TYPE = 'SET_MATCH_REPORT_TYPE';
export const START_LAST_REPORT_RUNNING = 'START_LAST_REPORT_RUNNING';
export const IGNORE_RUNNING_REPORT = 'IGNORE_RUNNING_REPORT';
export const RESET_RETAIL_MATCH_ACTION = 'RESET_RETAIL_MATCH_ACTION';
export const RESTART_RETAIL_MATCH_ACTION = 'RESTART_RETAIL_MATCH_ACTION';
export const SET_INCLUDE_ALL_BUDS_ACTION = 'SET_INCLUDE_ALL_BUDS_ACTION';
export const SET_MOST_RECENTLY_SUBMITTED_RETAIL_MATCH_REPORT = 'SET_MOST_RECENTLY_SUBMITTED_RETAIL_MATCH_REPORT';
export const SITE_IS_IN_DMA_INITIATE = "SITE_IS_IN_DMA_INITIATE";
export const SITE_IS_IN_DMA_SUCCESS = "SITE_IS_IN_DMA_SUCCESS";
export const SITE_IS_IN_DMA_FAILURE = "SITE_IS_IN_DMA_FAILURE";
export const SET_CHECKING_SITE_IS_IN_DMA = "SET_CHECKING_SITE_IS_IN_DMA";